import ArtistPage from './ArtistPage'

export default [{
	path: '/artist/:id',
	component: ArtistPage
}]


// WEBPACK FOOTER //
// ./src/pages/artist/artistRoutes.js